var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-right" } }, [
    _vm.isVisible
      ? _c("div", { staticClass: "modal slideout" }, [
          _c("div", {
            staticClass: "slideout__overlay",
            on: { click: _vm.close }
          }),
          _c(
            "div",
            { staticClass: "slideout__content" },
            [
              _c("icon-button", {
                staticClass: "modal__close",
                attrs: { icon: "close", size: "16px" },
                on: { click: _vm.close }
              }),
              _c("div", { staticClass: "slideout__content-header" }, [
                _c("div", { staticClass: "h3" }, [_vm._v("Stores")])
              ]),
              _c("div", { staticClass: "slideout__inner" }, [
                _c(
                  "div",
                  { staticClass: "slideout__options" },
                  [
                    _c("checkbox-toggle-all", {
                      attrs: {
                        label: "All Stores",
                        checked: _vm.toggleAllState,
                        allOptions: _vm.dropdownOptions
                      },
                      on: { input: _vm.toggleAllValues }
                    }),
                    _vm._l(_vm.dropdownOptions, function(value, key) {
                      return _c("checkbox-input", {
                        key: key,
                        attrs: { label: key, value: key, checked: value },
                        on: {
                          input: function($event) {
                            return _vm.updateCheckboxValue(key)
                          }
                        }
                      })
                    })
                  ],
                  2
                )
              ])
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }